var version = require("./version")

module.exports = isVirtualNode

function isVirtualNode(x) {
    return x && x.type === "VirtualNode" && x.version === version
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/is-vnode.js
// module id = 69
// module chunks = 0